import { elakay_API } from "../../config";

// Return / Replace configuration of a product (server_elakay
// elakay_controllers/product/returnPolicy.js). The server validates every
// field, checks ownership and the Provider ceiling; the page only displays.
const request = async (path, token, options = {}) => {
  try {
    const response = await fetch(`${elakay_API}${path}`, {
      ...options,
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...options.headers },
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) return { error: data.error || "Request failed", code: data.code || null, details: data.details || null, status: response.status };
    return data;
  } catch (error) {
    return { error: error.message || "Network error", code: "NETWORK_ERROR" };
  }
};

const pathFor = (mode, productId) => (mode === "provider"
  ? `/internal-dropshipping/provider/products/${encodeURIComponent(productId)}/return-policy`
  : `/products/${encodeURIComponent(productId)}/return-policy`);

export const getReturnPolicy = (token, productId, mode = "seller") => request(pathFor(mode, productId), token, { method: "GET" });

export const saveReturnPolicy = (token, productId, returnPolicy, mode = "seller") => request(pathFor(mode, productId), token, {
  method: "PUT",
  body: JSON.stringify({ returnPolicy }),
});

export const resetReturnPolicy = (token, productId, mode = "seller") => request(pathFor(mode, productId), token, {
  method: "PUT",
  body: JSON.stringify({ reset: true }),
});
